import Adyen from './adyen_tokenization';
import APIRequest from '../components/api_request';
import UserStore from '../reverb-js-common/user_store';
import UrlHelpers from '../components/shared/url_helpers';
import { browserInfo } from './browser_info';
import { ITokenizedCreditCardData } from './card_data';

interface BillingAddressInput {
  streetAddress: string;
  extendedAddress: string;
  locality: string;
  region: string;
  postalCode: string;
  countryCode: string;
}

interface CreditCardInput {
  id?: string | number;
  cardholderName: string;
  expirationMonth?: string;
  expirationYear?: string;
  cardNumber?: string;
  cvv?: string;
}

type TokenizedFields = ITokenizedCreditCardData | {};

function mapLegacyTokenizedCard(creditCardInput: CreditCardInput) {
  return {
    adyen_token: Adyen.tokenizeCard({
      number: creditCardInput.cardNumber,
      cvc: creditCardInput.cvv,
      holderName: creditCardInput.cardholderName,
      expiryMonth: creditCardInput.expirationMonth,
      expiryYear: creditCardInput.expirationYear,
    }),
  };
}

function mapCreditCardCreateParams(creditCardInput: CreditCardInput, tokenizedFields: TokenizedFields) {
  if (shouldUseAdyenCheckoutAPI()) {
    return { adyen_token: tokenizedFields };
  }

  return mapLegacyTokenizedCard(creditCardInput);
}

function mapCreditCardUpdateParams(creditCardInput: CreditCardInput) {
  if (shouldUseAdyenCheckoutAPIForUpdates()) {
    return {
      expiration_month: creditCardInput.expirationMonth,
      expiration_year: creditCardInput.expirationYear,
    };
  }

  return mapLegacyTokenizedCard(creditCardInput);
}
export function shouldUseAdyenCheckoutAPI() {
  return true; // adyen_checkout_api_vaulting rollout is at 100%. Here for Core compat
}

export const ADYEN_CHECKOUT_API_CARD_UPDATES = 'adyen_checkout_api_card_updates';
export function shouldUseAdyenCheckoutAPIForUpdates() {
  return UserStore.isExperimentEnabled(ADYEN_CHECKOUT_API_CARD_UPDATES);
}

export function saveCreditCard(
  creditCardInput: CreditCardInput,
  tokenizedFields: TokenizedFields,
  billingAddressInput: BillingAddressInput,
) {
  const commonParams = {
    browser_info: browserInfo(),
    channel: 'web',
    billing_address: {
      street_address: billingAddressInput.streetAddress,
      extended_address: billingAddressInput.extendedAddress,
      locality: billingAddressInput.locality,
      region: billingAddressInput.region,
      postal_code: billingAddressInput.postalCode,
      country_code: billingAddressInput.countryCode,
    },
    cardholder_name: creditCardInput.cardholderName,
  };

  const isCreate = !creditCardInput.id;
  if (isCreate) {
    return APIRequest.V3.post(
      UrlHelpers.myCreditCardsCreatePath(),
      {
        ...commonParams,
        ...mapCreditCardCreateParams(creditCardInput, tokenizedFields),
      },
    );
  }

  return APIRequest.V3.put(
    UrlHelpers.myCreditCardPath(creditCardInput.id),
    {
      ...commonParams,
      ...mapCreditCardUpdateParams(creditCardInput),
    },
  );
}

export default saveCreditCard;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/save_credit_card.ts